import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

const DoNotTranslateIcon = (props) => (
  <SvgIcon {...props}>
    <path style={{ fill: 'none' }} d="M0,0h24v24H0V0z" />
    <g>
      <path
        d="M3.1,3.7L1.7,5.1l3.4,3.4v7.1c0,0.9,0.7,1.6,1.6,1.6H13l0.8,2.3h2.4l2.4,2.4l1.3-1.3L3.3,4L3.1,3.7z M5.9,10.1
		c0-0.3,0-0.5,0.1-0.8l1.5,1.5c0.2,0.9,0.9,1.6,1.8,1.8l1.4,1.4c-0.2,0-0.5,0-0.9,0C7.7,14,5.9,12.3,5.9,10.1z"
      />
      <path d="M11.3,10.7l0.6,0.6c0.1-0.2,0.2-0.4,0.2-0.6H11.3z" />
      <path
        d="M20.7,4.7h-7.8l-0.8-2.3H6.7C5.8,2.3,5.1,3,5.1,3.9v0.7L7.5,7c0.6-0.5,1.4-0.8,2.3-0.8c1.1,0,1.9,0.4,2.7,1l-1,1
		c-0.3-0.3-0.8-0.6-1.6-0.6C9.4,7.6,9,7.8,8.6,8L10,9.4h3.5c0.1,0.2,0.1,0.5,0.1,0.8c0,0.9-0.2,1.6-0.6,2.2l3.8,3.8L16,13.9l2.4,2.4
		l0.7-0.7l-2.6-2.5l0,0c0.9-0.9,1.5-2.1,1.9-3.3h1.5V8.8h-3.5v-1h-1v1h-1.1l-1-3h7c0.5,0,0.8,0.4,0.8,0.8v10.9
		c0,0.4-0.3,0.8-0.8,0.8h-1.5l1.2,1.2h0.7c0.9,0,1.6-0.7,1.6-1.6V6.2C22.3,5.4,21.6,4.7,20.7,4.7z M17.5,9.8
		c-0.3,0.9-0.9,1.9-1.6,2.7c-0.2-0.2-0.5-0.5-0.7-0.9l-0.6-1.9H17.5z"
      />
    </g>
  </SvgIcon>
)

export default DoNotTranslateIcon
